import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output } from '@components/Reference';
import Sandbox from '@components/Sandbox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "box-shadow"
    }}>{`Box Shadow`}</h1>
    <p>{`Used to set box shadow attributes.`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class Reference`}</h2>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name">.elevation-0</Name>
        <Output mdxType="Output">box-shadow: 0;
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.elevation-1</Name>
        <Output mdxType="Output">box-shadow: <br /> <br />(0 1px 3px 0 rgba(0, 0, 0, 0.1),<br /> <br />0 1px 2px 0 rgba(0, 0, 0, 0.06));
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.elevation-2</Name>
        <Output mdxType="Output">box-shadow: <br /> <br />(0 4px 6px -1px rgba(0, 0, 0, 0.1),<br /> <br />0 2px 4px -1px rgba(0, 0, 0, 0.06));
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.elevation-3</Name>
        <Output mdxType="Output">box-shadow: <br /> <br />(0 10px 15px -3px rgba(0, 0, 0, 0.1),<br /> <br />0 4px 6px -2px rgba(0, 0, 0, 0.05));
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.elevation-4</Name>
        <Output mdxType="Output">box-shadow: <br /> <br />(0 20px 25px -5px rgba(0, 0, 0, 0.1),<br /> <br />0 10px 10px -5px rgba(0, 0, 0, 0.04));
        </Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.elevation-5</Name>
        <Output mdxType="Output">box-shadow: <br /> <br />0 25px 50px -12px rgba(0, 0, 0, 0.25)
        </Output>
    </Property>
    </Reference>
    <h3 {...{
      "id": "example"
    }}>{`Example`}</h3>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block ta-center flex flex-start flex-between flex-wrap" style={{
          width: '600px'
        }}>
      <div className="bg-grey-05 elevation-0 flex flex-middle p-4 mx-4 my-4">No Box Shadow</div>
      <div className="bg-grey-05 elevation-1 flex flex-middle p-4 mx-4 my-4">Box Shadow 1</div>
      <div className="bg-grey-05 elevation-2 flex flex-middle p-4 mx-4 my-4">Box Shadow 2</div>
      <div className="bg-grey-05 elevation-3 flex flex-middle p-4 mx-4 my-4">Box Shadow 3</div>
      <div className="bg-grey-05 elevation-4 flex flex-middle p-4 mx-4 my-4">Box Shadow 4</div>
      <div className="bg-grey-05 elevation-5 flex flex-middle p-4 mx-4 my-4">Box Shadow 5</div>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="elevation-0">No Box Shadow</div>
    <div className="elevation-1">Box Shadow 1</div>
    <div className="elevation-2">Box Shadow 2</div>
    <div className="elevation-3">Box Shadow 3</div>
    <div className="elevation-4">Box Shadow 4</div>
    <div className="elevation-5">Box Shadow 5</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "hover-state"
    }}>{`Hover state`}</h2>
    <p>{`   Change the amount of box shadow on an element on hover. The syntax is : `}<inlineCode parentName="p">{`.hover:elevation-{value}`}</inlineCode>{`.`}</p>
    <h3 {...{
      "id": "example-1"
    }}>{`Example`}</h3>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block ta-center flex flex-start flex-between flex-wrap" style={{
          width: '600px'
        }}>
      <div className="bg-grey-05 hover:elevation-4 flex flex-middle p-4 mx-4 my-4">Box Shadow 4 on Hover</div>
      </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="hover:elevation-4">Box Shadow 4</div>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      